var _circle, _path, _circle2, _circle3, _path2, _path3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#AA7BCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.7783H28.8889C31.0981 25.7783 32.8889 27.5692 32.8889 29.7783V43.1117L30.5669 41.4095C29.881 40.9066 29.0526 40.6355 28.202 40.6355H20C17.7909 40.6355 16 38.8446 16 36.6355V29.7783C16 27.5692 17.7909 25.7783 20 25.7783Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5556,
    cy: 33.3341,
    r: 0.88881,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.7775,
    cy: 33.3341,
    r: 0.88881,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 17.334H30.2222C28.013 17.334 26.2222 19.1248 26.2222 21.334V36.0007L28.7111 34.134C29.4034 33.6147 30.2456 33.334 31.1111 33.334H39.9999C42.2091 33.334 43.9999 31.5431 43.9999 29.334V21.334C43.9999 19.1248 42.2091 17.334 39.9999 17.334Z",
    fill: "#AA7BCB",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7778 22.9097C33.7778 22.3845 34.1334 21.334 35.5556 21.334C36.9778 21.334 37.3334 22.3845 37.3334 22.9097C37.3334 24.7481 35.5556 25.0108 35.5556 27.1118",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5556,
    cy: 29.3342,
    r: 0.888889,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.103ef480963e4ee6b1798c0882d29f7e.svg";
export { ForwardRef as ReactComponent };